import { PayloadAction } from "@reduxjs/toolkit";

import { MyFleetState } from "../../types";

export const setSearchValue = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState["searchValue"]>
) => {
  state.searchValue = action.payload;
};
